import React from "react";
import styled from "styled-components";
import TitleSvg from "../img/title-about.svg";
import device from "../helpers/device";

export default function About({ ...props }) {
  return (
    <Wrapper {...props}>
      <Title>
        <img src={TitleSvg} alt="ABOUT" />
      </Title>
      <Contents>
        <Row>
          <Head>
            <p>日時</p>
          </Head>
          <Body>
            <p>2019年2月22日（金）</p>
          </Body>
        </Row>
        <Row>
          <Head>参加対象</Head>
          <Body>
            サイバーエージェントグループのエンジニア・クリエイター
            正社員、契約社員
            <br />
            ※業務委託、派遣の方は参加できません。あらかじめご了承ください。
          </Body>
        </Row>
        <Row>
          <Head>スケジュール</Head>
          <Body>
            13:00 開場
            <br />
            13:30 基調講演
            <br />
            14:00-18:00 セッション
            <br />
            18:10-18:30 クロージングトーク
          </Body>
        </Row>
      </Contents>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 60px;
  @media ${device.mobileL} {
    padding-top: 100px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin: 0 auto 30px auto;
  width: ${125 * 0.9}px;
  @media ${device.mobileL} {
    width: 125px;
    margin: 0 auto 50px auto;
  }
  > img {
    width: 100%;
  }
`;

const Contents = styled.div`
  width: 90%;
  margin: 0 auto;
  @media ${device.mobileL} {
    width: 711px;
  }
`;

const Row = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  border-bottom: 4px solid #3f261f;
  max-width: 560px;
  flex-direction: row;
  justify-content: space-between;
  @media ${device.mobileL} {
  }
`;

const Head = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
  min-height: 60px;
  width: 30%;
  line-height: 1.5;
  @media ${device.mobileL} {
    width: 200px;
  }
`;

const Body = styled.div`
  background: #fff;
  display: flex;
  padding: 15px 0px 15px 15px;
  width: 70%;
  align-items: center;
  line-height: 1.5;
  @media ${device.mobileL} {
    width: 500px;
    padding: 30px 20px;
  }
`;
